import type { LoggingApi } from './types';

/**
 * LoggingProxy class defines the proxy of logging instrumentation.
 * Prototype definition comes from 'legacy-js/common/instrumentation/log'.
 * They need to be implemented if we want to replace logging tool.
 */
export default class LoggingProxy {
  logging: LoggingApi;
  /**
   * Initialize logging tool with given value.
   * @param {object} logging - The logging tool passed from init function.
   */
  constructor(logging: LoggingApi) {
    this.logging = logging;
  }

  trace(methodName?: string, message?: unknown, scenarioName?: string) {
    return this.logging.trace(methodName, message, scenarioName);
  }

  error(methodName?: string, message?: unknown, scenarioName?: string) {
    return this.logging.error(methodName, message, scenarioName);
  }

  verbose(methodName?: string, message?: unknown, scenarioName?: string) {
    return this.logging.verbose(methodName, message, scenarioName);
  }

  perf(metric?: string, value?: unknown, scenarioName?: string) {
    return this.logging.perf(metric, value, scenarioName);
  }

  startScenario(scenarioName?: string, message?: unknown) {
    return this.logging.startScenario(scenarioName, message);
  }

  endScenario(scenarioName?: string, result?: unknown, message?: unknown) {
    return this.logging.endScenario(scenarioName, result, message);
  }

  pageRouteStart(pagePath?: string, viewName?: string, previousPath?: string, previousView?: string) {
    return this.logging.pageRouteStart ? this.logging.pageRouteStart(pagePath, viewName, previousPath, previousView) : null;
  }

  pageRoutePageLoadDuration(pagePath?: string, loadDuration?: number, isRecorded?: boolean) {
    return this.logging.pageRoutePageLoadDuration ? /* istanbul ignore next */ this.logging.pageRoutePageLoadDuration(pagePath, loadDuration, isRecorded) : null;
  }

  pageRouteEnd(
    pagePath?: string,
    viewName?: string,
    activityId?: string,
    stayDuration?: number,
    nextPagePath?: string,
    isUnload?: boolean
  ) {
    return this.logging.pageRouteEnd ? this.logging.pageRouteEnd(pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload) : null;
  }

  flushLogs(callback?: () => unknown) {
    return this.logging.flushLogs(callback);
  }

  logError(methodName?: string, message?: unknown) {
    return this.logging.logError(methodName, message);
  }
}
